export enum AccountTransactionType {
  CREDIT = 'credit',
  DEBIT = 'debit',
}

export enum CheckStatus {
  PENDING = 'pending',
  APPLIED = 'applied',
}

export enum Currency {
  USD = 'USD',
  NIS = 'NIS',
  JOD = 'JOD',
  EURO = 'EURO',
}

export enum LocaleCode {
  EN = 'EN',
  AR = 'AR',
}
